import ScoutedCandidateListPage from './ScoutedCandidateListPage';

export default ScoutedCandidateListPage;